import React, { useEffect, useRef, useState } from 'react';
import MobileProductMenu from './MobileProductMenu';
import MobileProductQuickFilters from './MobileProductQuickFilters';

export default function MobileProductsToolbar({
  query,
  totalCount,
  loading,
  refreshing,
  filterCount,
  onSearch,
  onFilters,
  onQuickFilter,
  onReset,
  onRefresh,
  onCreate,
  onBulkCreate,
  onRates,
}) {
  const [search, setSearch] = useState(query.search);
  const searchTimer = useRef(null);
  const onSearchRef = useRef(onSearch);
  onSearchRef.current = onSearch;
  useEffect(() => {
    clearTimeout(searchTimer.current);
    setSearch(query.search);
  }, [query.search]);
  useEffect(() => () => clearTimeout(searchTimer.current), []);
  const changeSearch = value => {
    setSearch(value);
    clearTimeout(searchTimer.current);
    const next = value.trim();
    if (next !== query.search) {
      searchTimer.current = setTimeout(() => onSearchRef.current(next), next ? 250 : 0);
    }
  };
  return (
    <section className='mp-toolbar' aria-label='Керування товарами'>
      <div className='mp-heading'>
        <h1>
          Товари <small>{loading ? '…' : totalCount.toLocaleString('uk-UA')}</small>
        </h1>
        <div className='mp-toolbar-primary'>
          <button type='button' className='btn btn-sm btn-dark' onClick={onCreate}>
            <i className='bi bi-plus' aria-hidden='true' /> Додати
          </button>
          <MobileProductMenu label='Інші дії з товарами' className='mp-tools-menu'>
            <button type='button' className='dropdown-item' onClick={onBulkCreate}>
              <i className='bi bi-file-earmark-plus mr-2' aria-hidden='true' />
              Масове створення
            </button>
            <button type='button' className='dropdown-item' onClick={onRates}>
              <i className='bi bi-currency-exchange mr-2' aria-hidden='true' />
              Курси валют
            </button>
          </MobileProductMenu>
        </div>
      </div>
      <form
        className='mp-search'
        onSubmit={event => {
          event.preventDefault();
          clearTimeout(searchTimer.current);
          if (search.trim() !== query.search) onSearchRef.current(search.trim());
        }}
      >
        <input
          className='form-control form-control-sm'
          type='search'
          aria-label='Пошук товарів'
          placeholder='Назва або артикул'
          value={search}
          onChange={event => changeSearch(event.target.value)}
        />
      </form>
      <MobileProductQuickFilters query={query} onChange={onQuickFilter} />
      <div className='mp-toolbar-actions'>
        <button
          type='button'
          className='btn btn-sm btn-dark'
          onClick={onFilters}
          aria-label='Фільтри та порядок'
        >
          <i className='bi bi-sliders mr-1' aria-hidden='true' />
          Фільтри{filterCount > 0 && <span className='mp-count'>{filterCount}</span>}
        </button>
        <div>
          <button
            type='button'
            className='btn btn-sm btn-light'
            disabled={loading || refreshing}
            aria-busy={refreshing}
            onClick={onRefresh}
            aria-label='Оновити товари'
            title='Оновити товари'
          >
            <i className='bi bi-arrow-clockwise' aria-hidden='true' />
          </button>
          <button
            type='button'
            className='btn btn-sm btn-light'
            onClick={() => {
              clearTimeout(searchTimer.current);
              setSearch('');
              onReset();
            }}
            aria-label='Очистити фільтри'
            title='Очистити фільтри'
          >
            <i className='bi bi-x-circle' aria-hidden='true' />
          </button>
        </div>
      </div>
    </section>
  );
}
